import { registerPlugin } from '@capacitor/core';

export interface TestFlightPlugin {
  isSimulatorOrTestFlight(options: {
    value: string;
  }): Promise<{ value: boolean }>;
}

export default registerPlugin<TestFlightPlugin>('TestFlight');
